import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Divider, Drawer, Grid, InputLabel, MenuItem, Popover, Select, Stack, TextField, Typography } from "@mui/material";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import MenuIcon from '@mui/icons-material/Menu';

import globalStyles from '../../../../assets/styles/global.module.scss';
import styles from '../../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss';
import formStyles from '../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss';

import { primaryColor, errorColor, blackColor } from '../../../../utils/colors';
import IconsColor from '../../../utility/iconsColor';
import GlobalButton from "../../../utility/globalButton/button";

import { dynamicUrlVisitWebsiteBtnTooltipText, getSubBtnNameFromGenericData, getButtonCount, isCustomBtn, isInteractiveTypeMessageList, isVisitWebsiteBtn, shouldShowAllOptionsButton, shouldShowDrawerButtons, shouldShowLimitedButtons, shouldShowLimitedButtonsSlice, isTemplateCategoryAuthentication, isCatalogTemplate, shouldRenderBtnIcon, filterBtnData, isInteractiveCatalogTemplate, isInteractiveTypeText, isOrderDetailsInteractiveTemplate, isInteractiveTemplateTypeList, isCallPermissionRequestTemplate, isInteractiveTypeMessageRequestContactInfo } from "../../channels/global/whatsapp/templates/utils";
import { useTemplateLibraryStore } from "../../../../store/templateLibraryStore";
import { StyledMenu } from "../utils/StyledMenu";
import { commonButtonStyle, getButtonsIconByName, hasDuplicateButtonText, isInvalidDynamicWebsiteUrl, isInvalidUrl, isTemplateCreated } from "../constant";
import PrimaryIOSSwitch from "../../../utility/switch/primaryIOSSwitch";
import { formatString, onClickOfFlowButton, toCapitalizedCase } from "../../../../utils/constants";
import { useSearchParams } from "react-router-dom";
import { useCarouselFunctions } from "../utils/useCarouselFunctions";
import TouchTooltip from "../utils/TouchTooltip";
import VariableDisclaimer from "../utils/VariableDisclaimer";
import CallPermissionRequestPreview from "./CallPermissionRequestPreview";

const WhatsAppMessageButtonsPreview = (props: any) => {

    const { template, editable, checkDisableAddButton, handleClose, getMenuDisableFlag, menuPosition: menuPositionProp,
        handleAddActionsButton, renderCustomButtonField, getInput, flagShowVariableTooltipForVisitWebsite, handleDeleteActionBtn, 
        setOnChangeOfPayloadObject, checkForAddDynamicVar, getWebsiteUrlValue, handleChangeCallField, handleChangeFieldVal, 
        isFlowButton, handleSampleTextChange, calculateMenuPosition, inValidId: inValidIdProp, drawerContainerRef, displayTemplatePayload 
    } = props;

    const createTemplatePayload = useTemplateLibraryStore((state) => state.createTemplatePayload);
    const metaInformation = (!editable && displayTemplatePayload) ? displayTemplatePayload : createTemplatePayload;
    const setCreateTemplatePayload = useTemplateLibraryStore((state) => state.setCreateTemplatePayload);
    const interactiveTypeList = useTemplateLibraryStore((state) => state.interactiveTypeList);
    const whatsappTemplateButtonGenericData = useTemplateLibraryStore((state) => state.whatsappTemplateButtonGenericData);
    const invalidPayloadObjectId = useTemplateLibraryStore((state) => state.invalidPayloadObjectId);
    const inValidIdFromStore = useTemplateLibraryStore((state) => state.inValidId) ?? [];
    const templateLibraryCategoryList = useTemplateLibraryStore((state) => state.templateLibraryCategoryList);
    const whatsappTemplateTypes = useTemplateLibraryStore((state) => state.whatsappTemplateTypes);
    
    const inValidId = inValidIdProp ?? inValidIdFromStore;

    const [addBtnOpenMenu, setAddBtnOpenMenu] = useState<boolean>(false);
    const [addButtonAnchorEl, setAddButtonAnchorEl] = useState<HTMLElement | null>(null);
    const [openButtonIndex, setOpenButtonIndex] = useState<number | null>(null);
    const [buttonAnchorEl, setButtonAnchorEl] = useState<{ [key: number]: HTMLElement | null }>({});
    const previousButtonCount = useRef<number>(0);
    const hasInitializedButtonCount = useRef<boolean>(false);

    const [menuPositionLocal, setMenuPositionLocal] = useState<'top' | 'bottom'>('bottom');
    const [openDrawer, setOpenDrawer] = React.useState(false);

    const [searchParams] = useSearchParams();

    const id = searchParams.get('id');
    const menuPosition = menuPositionProp !== undefined ? menuPositionProp : menuPositionLocal;
    const openMenuOptions = Boolean(addButtonAnchorEl);
    
    const { isScreenBelow1600, isMobileScreen } = useCarouselFunctions();
    
    // Constants
    const isAuthenticationTemplate = isTemplateCategoryAuthentication(templateLibraryCategoryList, createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id);
    const isTemplateTypeCatalog = isCatalogTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id);
    const isTemplateTypeCallPermissionRequest = isCallPermissionRequestTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id);
    
    const isInteractiveTypeCatalog = isInteractiveCatalogTemplate(interactiveTypeList, createTemplatePayload?.interactive_type_id);
    const isInteractiveTemplateTypeText = isInteractiveTypeText(interactiveTypeList, createTemplatePayload?.interactive_type_id);
    const isInteractiveTypeList = isInteractiveTemplateTypeList(metaInformation, interactiveTypeList ?? []);
    const isInteractiveTypeRequestContactInfo = isInteractiveTypeMessageRequestContactInfo(createTemplatePayload?.interactive_type_id, interactiveTypeList);
    
    const isButtonActionLocked = isTemplateCreated(createTemplatePayload) || isAuthenticationTemplate || isTemplateTypeCatalog || isInteractiveTypeCatalog || isInteractiveTypeRequestContactInfo;

    const showOrderDetailsReviewAndPayButton = isOrderDetailsInteractiveTemplate(metaInformation, interactiveTypeList ?? []);

    // Functions
    const handlePopoverClose = () => {
        setButtonAnchorEl({});
        setOpenButtonIndex(null);
    };

    const handleDrawerOpen = (e: React.MouseEvent) => {
        e.stopPropagation(); 
        e.preventDefault(); 
        setOpenDrawer(true);
    };

    const handleDrawerClose = () => {
        setOpenDrawer(false);
    };

    const handleButtonClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
        event.stopPropagation();
        if (editable) {
            setButtonAnchorEl({ [index]: event.currentTarget as HTMLElement });
            setOpenButtonIndex(index);
        }
        else {
            const subBtnData = metaInformation?.whatsapp_template_data?.whatsapp_template_button?.[index]?.whatsapp_template_button_data?.[0];
            onClickOfFlowButton(subBtnData, id);
        }
    };

    const handleMenuItemsClick = (event: React.MouseEvent<HTMLElement>, btnOption: any, subType: any) => {
        event.stopPropagation();
        handleAddActionsButton(btnOption?.whatsapp_template_button_type_id, subType?.whatsapp_template_button_sub_type_id);
        setAddButtonAnchorEl(null);
        handleClose();
    };

    const isButtonInvalid = (buttonIndex: number): boolean => {
        if (!editable || !createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button || isTemplateCreated(createTemplatePayload)) {
            return false;
        }

        // Check if the button data is empty
        const action = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.[buttonIndex];
        if (!action?.whatsapp_template_button_data?.length) {
            return false;
        }
        
        // Check if the button text is unique
        const templateButtons = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button ?? [];
        if ((action?.whatsapp_template_button_data ?? []).some((_: any, dataIndex: number) =>
            hasDuplicateButtonText(templateButtons, buttonIndex, dataIndex)
        )) {
            return true;
        }

        for (const buttonData of action?.whatsapp_template_button_data) {
            
            const fieldDataList = buttonData?.whatsapp_template_button_sub_type_field_data ?? [];

            for (const field of fieldDataList) {
                
                if (field?.field_static_value_flag === true) continue;

                const fieldName = (field?.field_name ?? "").toLowerCase();
                const fieldType = (field?.field_type ?? "").toLowerCase();
                const value = field?.whatsapp_template_button_sub_type_field_value;

                if (fieldName === "website url") {
                    const urlTypeField = fieldDataList.find((f: any) => (f?.field_name ?? "").toLowerCase() === "url type") as any;
                    const selectedUrlType = urlTypeField?.field_option_data?.find(
                        (option: any) => option?.field_option_id === urlTypeField?.whatsapp_template_button_sub_type_field_option_id
                    );
                    const isDynamicUrl = selectedUrlType?.field_option_value?.toLowerCase() === "dynamic";

                    if (isDynamicUrl) {
                        const sample = field?.whatsapp_template_button_field_data_variable?.[0]?.whatsapp_template_dynamic_variable_sample_value?.trim();
                        if (!sample || isInvalidUrl(sample)) return true;
                        
                        const strVal = typeof value === "string" ? value.trim() : "";
                        if (!strVal || isInvalidDynamicWebsiteUrl(strVal)) return true;
                    } else {
                        const strVal = typeof value === "string" ? value.trim() : "";
                        if (!strVal || isInvalidUrl(strVal)) return true;
                    }
                    continue;
                }

                switch (true) {
                    case fieldType === "textfield" && fieldName !== "button description" && fieldName !== "website url": {
                        const strVal = typeof value === "string" ? value.trim() : "";
                        if (!strVal) return true;
                        break;
                    }

                    case fieldType === "autocomplete": {
                        const optionId = field?.whatsapp_template_button_sub_type_field_option_id;

                        if (optionId == null || Number(optionId) === 0) {
                            if (!isFlowButton(action?.whatsapp_template_button_type_id, whatsappTemplateButtonGenericData) || value == null) {
                                return true;
                            }
                        }
                        break;
                    }

                    case fieldName === "payload" &&
                        Array.isArray(value): {
                        const hasEmpty = value?.some((payload: any) => (!payload?.payload_key?.trim() || !payload?.payload_key_value?.trim()));
                        if (hasEmpty) return true;
                        break;
                    }

                    default: {
                        const fieldId = field?.whatsapp_template_button_sub_type_field_id;

                        if (invalidPayloadObjectId?.length && fieldId != null && invalidPayloadObjectId.includes(fieldId)) {
                            return true;
                        }
                    }
                }
            }
        }

        return false;
    };

    const renderAddNewButton = () => {
        return (
            <>
                <Button
                    id="demo-customized-button"
                    aria-controls={addBtnOpenMenu ? 'demo-customized-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={addBtnOpenMenu ? 'true' : undefined}
                    variant="contained"
                    disableElevation
                    onClick={(e) => { setAddButtonAnchorEl(e.currentTarget); }}
                    className={styles.addButton}
                    disabled={createTemplatePayload?.whatsapp_template_id ? true : checkDisableAddButton()}
                    style={{ opacity: createTemplatePayload?.whatsapp_template_id ? 0.5 : checkDisableAddButton() ? 0.5 : 1 }}
                    startIcon={<IconsColor iconName="plus" width="12px" height="12px" fillColor="#1B7D4E" />} 
                    endIcon={<ArrowDropDownIcon sx={{width: "22px !important", height: "22px !important"}} />}
                >
                    {createTemplatePayload?.whatsapp_template_flag_interactive_message && isInteractiveTypeMessageList(createTemplatePayload?.interactive_type_id, interactiveTypeList) 
                        ? "Add Row" 
                        : "Add Button"
                    }
                </Button>
            </>
        )
    }

    const renderStyledMenu = () => {
        return (
            <>
                <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                        'aria-labelledby': 'demo-customized-button',
                        className: formStyles.formPopoverMenuList,
                    }}
                    anchorEl={addButtonAnchorEl}
                    open={openMenuOptions}
                    onClose={() => { setAddButtonAnchorEl(null); handleClose(); }}
                    position={menuPosition}
                >
                    {whatsappTemplateButtonGenericData && whatsappTemplateButtonGenericData?.length > 0 && filterBtnData(whatsappTemplateButtonGenericData)?.map((btnOption: any, index: number) => {
                        return <React.Fragment key={index}>
                            <div className={formStyles.formPopoverTitle}>
                                {toCapitalizedCase(formatString(btnOption?.whatsapp_template_button_type_name))}
                            </div>
                            
                            {btnOption?.whatsapp_template_button_sub_type_data?.filter((subType: any) => subType?.whatsapp_template_button_sub_type_name?.toLowerCase() !== "marketing opt-out").map((subType: any, ind: number) => {
                                return <React.Fragment key={ind}>
                                    <MenuItem
                                        disabled={getMenuDisableFlag(btnOption?.whatsapp_template_button_type_id, subType)}
                                        onClick={(e) => { handleMenuItemsClick(e, btnOption, subType); }} disableRipple>
                                        <Grid container alignItems={"center"} className={formStyles.formPopoverItemRow}> 
                                            <Grid item>{getButtonsIconByName(subType?.whatsapp_template_button_sub_type_name)}</Grid> 
                                            <Grid item>
                                                <Grid container direction={"column"} className={formStyles.formPopoverItemColumn}>
                                                    <Grid item className={formStyles.formPopoverItemLabel}>
                                                        {toCapitalizedCase(formatString(subType?.whatsapp_template_button_sub_type_name))}
                                                    </Grid>
                                                    {getMenuDisableFlag(btnOption?.whatsapp_template_button_type_id, subType) && 
                                                        <Grid item className={formStyles.formPopoverItemDesc}>
                                                            {subType?.whatsapp_template_button_sub_type_description}
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </MenuItem>
                                </React.Fragment>
                            })}

                            <Grid item className={formStyles.formPopoverDivider}>
                                {index !== filterBtnData(whatsappTemplateButtonGenericData)?.length - 1 && 
                                    <Divider />
                                }
                            </Grid>
                        </React.Fragment>
                    })}
                </StyledMenu>
            </>
        )
    }

    const renderBtnIcon = (btn: any) => {
        if(shouldRenderBtnIcon(metaInformation, btn?.btnText)){    
            return btn.icon;
        }
        return undefined;
    }

    // Interactive Template - Order Details
    const renderReviewAndPayButton = () => {

        if (!showOrderDetailsReviewAndPayButton) {
            return null;
        }

        return (
            <GlobalButton
                className=""
                sx={{ ...commonButtonStyle, cursor: 'default' }}
                buttonText="Review and Pay"
                onClick={() => {}}
            />
        );
    };

    // Call Permission Request Template
    const renderChoosePrefenceButton = () => {

        if (!isTemplateTypeCallPermissionRequest) {
            return null;
        }

        return <CallPermissionRequestPreview />;
    }

    const shouldShowAddButton = () => {
        return editable && !isButtonActionLocked && !showOrderDetailsReviewAndPayButton && !isInteractiveTemplateTypeText && !isTemplateTypeCallPermissionRequest;
    }

    // Use Effects
    useEffect(() => {
        if (!editable) {
            handlePopoverClose();
            setAddButtonAnchorEl(null);
            setAddBtnOpenMenu(false);
        }
    }, [editable]);

    useEffect(() => {
        const updateMenuPosition = () => {
            if (openMenuOptions && addButtonAnchorEl && menuPositionProp === undefined) {
                const position = calculateMenuPosition(addButtonAnchorEl);
                setMenuPositionLocal(position);
            }
        };

        updateMenuPosition();
        window.addEventListener('resize', updateMenuPosition);

        return () => window.removeEventListener('resize', updateMenuPosition);
    }, [openMenuOptions, addButtonAnchorEl, calculateMenuPosition, menuPositionProp]);

    useEffect(() => {
        const currentButtonCount = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.length || 0;

        if (!hasInitializedButtonCount.current) {
            previousButtonCount.current = currentButtonCount;
            hasInitializedButtonCount.current = true;
            return;
        }

        previousButtonCount.current = currentButtonCount;
    }, [createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.length, editable]);

    useEffect(() => {
        const totalButtons = getButtonCount(metaInformation);
        if (openDrawer && !isInteractiveTypeList && totalButtons <= 3) {
            setOpenDrawer(false);
        }
    }, [metaInformation, openDrawer, isInteractiveTypeList]);
    
    if (!template) {
        return null;
    }

    return (
        <>
            {editable && (
                <Stack>
                    {renderReviewAndPayButton()}
                    {renderChoosePrefenceButton()}
                    {template?.buttons?.map((btn: any, index: number) => {
                        return (
                            <GlobalButton
                                key={index}
                                className=""
                                sx={{ 
                                    cursor: editable ? 'pointer' : 'default',
                                    ...commonButtonStyle, 
                                    ...(editable && isButtonInvalid(index) && 
                                        { 
                                            border: `1px solid ${errorColor} !important`, 
                                            boxSizing: 'border-box' 
                                        }
                                    ),
                                }}
                                startIcon={renderBtnIcon(btn)}
                                buttonText={btn.text}
                                onClick={(e) => {handleButtonClick(e, index)}}
                                id={`preview-button-${index}`}
                            />
                        );
                    })}
                </Stack>
            )}

            {/* Add Button */}
            {shouldShowAddButton() && (
                <Box mt={1} className={styles.buttonsActionsDisabledCursor}>
                    {isTemplateCreated(createTemplatePayload) ? (
                        <TouchTooltip title="New buttons cannot be added once the template has been created." >
                            <span className={globalStyles.clickable}>
                                {renderAddNewButton()}
                            </span>
                        </TouchTooltip>
                    ) : (
                        renderAddNewButton()
                    )}

                    {renderStyledMenu()}
                </Box>
            )}

            {/* Buttons Preview  */}
            {!editable && (
                <Stack>
                    {renderReviewAndPayButton()}
                    {renderChoosePrefenceButton()}
                    {shouldShowLimitedButtons(metaInformation, interactiveTypeList) && template?.buttons?.map((btn: any, index: number) => (
                        <GlobalButton
                            key={index}
                            className=""
                            sx={commonButtonStyle}
                            startIcon={renderBtnIcon(btn)}
                            buttonText={btn.text}
                            onClick={(e: any) => handleButtonClick(e, index)}
                        />
                    ))}
                    {shouldShowLimitedButtonsSlice(metaInformation, interactiveTypeList) && template?.buttons?.slice(0, 2).map((btn: any, index: number) => (
                        <GlobalButton
                            key={index}
                            className=""
                            sx={commonButtonStyle}
                            startIcon={renderBtnIcon(btn)}
                            buttonText={btn.text}
                            onClick={(e: any) => handleButtonClick(e, index)}
                        />
                    ))}
                    {shouldShowAllOptionsButton(metaInformation, interactiveTypeList) && (
                        <GlobalButton
                            className=""
                            sx={commonButtonStyle}
                            startIcon={<MenuIcon style={{ display: "flex" }} />}
                            buttonText={isInteractiveTypeMessageList(metaInformation?.interactive_type_id, interactiveTypeList ?? []) ? metaInformation?.interactive_list_button_text : "See All Options"}
                            onClick={(e: React.MouseEvent<HTMLElement>) => handleDrawerOpen(e)}
                        />
                    )}
                </Stack>
            )}

            {/* Drawer for See All Options */}
            {!editable && (
                <div style={{ position: "relative"}}>
                    <Drawer
                        open={openDrawer}
                        anchor='bottom'
                        onClose={handleDrawerClose}
                        variant="temporary"
                        ModalProps={{
                            container: drawerContainerRef?.current ?? undefined,
                            disableEnforceFocus: true,
                            keepMounted: true,
                            disablePortal: false,
                            disableScrollLock: true,
                        }}
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            zIndex: 100,
                            '& .MuiModal-root': { position: 'absolute', inset: 0 },
                            '& .MuiBackdrop-root': { position: 'absolute', inset: 0 },
                            '& .MuiDrawer-paper': { boxShadow: '0 -2px 6px rgba(0, 0, 0, 0.12) !important' },
                            transition: openDrawer ? 'opacity 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'opacity 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                        }}
                        PaperProps={{
                            sx: {
                                position: 'absolute !important',
                                bottom: 0,
                                left: 3,
                                right: 3,
                                width: '100% !important',
                                maxWidth: isMobileScreen ? '88% !important' : '90% !important',
                                margin: 0,
                            }
                        }}
                        BackdropProps={{ sx: { position: 'absolute', inset: 0, borderRadius: "8px" } }}
                        SlideProps={{
                            direction: openDrawer ? "up" : "down",
                            timeout: { enter: 0, exit: 0 },
                            style: {
                                borderRadius: "32px 32px 8px 8px",
                                border: "2px solid #FAF0F0",
                                padding: "15px",
                                transition: openDrawer ? 'all 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'all 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                            }
                        }}
                    >
                        <Grid container direction={"column"} gap={1} className={styles.buttonPreviewDrawer__header}>

                            <Grid item xs={12} className={styles.buttonPreviewDrawer__titleSeparatorContainer}>
                                <Box className={styles.buttonPreviewDrawer__titleSeparator}></Box>
                            </Grid>

                            <Grid container justifyContent={"space-between"} alignItems={"center"} gap={1}>
                                <CloseIcon className={styles.buttonPreviewDrawer__closeIcon} onClick={handleDrawerClose} />
                                <Grid item className={styles.buttonPreviewDrawer__allOptionText}>
                                    {isInteractiveTypeList ? (metaInformation?.interactive_list_button_text || "See All Options") : "All Options"}
                                </Grid>
                                <Grid></Grid>
                            </Grid>
                            
                        </Grid>

                        {
                            shouldShowDrawerButtons(metaInformation) && template?.buttons?.map((btn: any, index: number) => {
                                return (
                                    <Grid container key={index}>
                                        <Grid item className={`${styles.buttonPreviewDrawer__button} ${(editable && isButtonInvalid(index)) ? styles.buttonPreviewDrawer__buttonError : ''}`}>
                                            
                                            <Grid container justifyContent={"start"} gap={1} alignItems={"center"} flexWrap={"nowrap"} 
                                                onClick={(e) => { e.stopPropagation(); handleButtonClick(e, index); }}
                                            >
                                                {shouldRenderBtnIcon(metaInformation, btn?.btnText) &&
                                                    <Grid item>
                                                        {btn?.icon}
                                                    </Grid>
                                                }

                                                <Grid item>
                                                    <Grid container direction={"column"}>
                                                        <Grid item>
                                                            {btn?.text}
                                                        </Grid>
                                                        <Grid item className={styles.buttonPreviewDrawer__buttonDescription}>
                                                            {btn?.description}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                        </Grid>
                                    </Grid>
                                )
                            })
                        }
                    </Drawer>
                </div>
            )}

            {editable && (openButtonIndex !== null && buttonAnchorEl[openButtonIndex]) && 
                <Popover
                    open={openButtonIndex !== null}
                    anchorEl={buttonAnchorEl[openButtonIndex] || null}
                    onClose={handlePopoverClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                    PaperProps={{ 
                        className: styles.addButtonDialogPaper,
                    }}
                >
                    {createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.length > 0 && createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button
                        .filter((action: any, ind: number) => ind === openButtonIndex)
                        .map((action: any) => {
                        return (
                            <React.Fragment key={openButtonIndex}>
                                <Grid container className={styles.buttonPreviewPopover__callToActionGrid}>
                                    
                                    <Grid item xs={12} display={"flex"} alignItems={"start"} justifyContent={"space-between"} flexWrap={"nowrap"} gap={0.5} 
                                        className={styles.buttonPreviewPopover__stickyHeader}
                                    >
                                        <Grid item className={styles.buttonPreviewPopover__callToActionGrid__text} sx={{ flex: 1, minWidth: 0 }}>
                                        {
                                            toCapitalizedCase(formatString(
                                                whatsappTemplateButtonGenericData?.find(
                                                    (btn) => Number(btn?.whatsapp_template_button_type_id) === Number(action?.whatsapp_template_button_type_id)
                                                )?.whatsapp_template_button_type_name
                                            )) ?? ""
                                        }
                                        </Grid>

                                        <Grid item display={"flex"} alignItems={"center"} gap={1} flexWrap={"nowrap"} sx={{ flexShrink: 0 }}>
                                            {isVisitWebsiteBtn(getSubBtnNameFromGenericData(whatsappTemplateButtonGenericData, action?.whatsapp_template_button_type_id, action?.whatsapp_template_button_data[0]?.whatsapp_template_button_sub_type_id)) && (
                                                <Grid container direction={"row"} alignItems={"center"} gap={0.5} flexWrap={"nowrap"}>
                                                    <InputLabel 
                                                        className={styles.buttonPreviewPopover__formLabel} 
                                                        style={{ opacity: createTemplatePayload?.whatsapp_template_id ? "0.5" : "1", margin: 0 }}
                                                    >
                                                        Allow Tracking
                                                    </InputLabel>

                                                    <PrimaryIOSSwitch
                                                        disabled={Boolean(createTemplatePayload?.whatsapp_template_id)}
                                                        checked={action?.flag_allow_tracking}
                                                        onChange={() => {
                                                            setCreateTemplatePayload({
                                                                ...createTemplatePayload,   
                                                                whatsapp_template_data: {
                                                                    ...createTemplatePayload?.whatsapp_template_data,
                                                                    whatsapp_template_button: createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.map((buttons: any) => ({
                                                                        ...buttons,
                                                                        flag_allow_tracking: !buttons?.flag_allow_tracking
                                                                    }))
                                                                }
                                                            });
                                                        }}
                                                    />
                                                </Grid>   
                                            )}

                                            <DeleteIcon 
                                                className={`${globalStyles.displayFlex} ${styles.buttonPreviewPopover__closeActionButton} ${isButtonActionLocked ? styles.buttonPreviewPopover__disableCloseActionBtn : ''}`}
                                                onClick={() => { 
                                                    if (!isButtonActionLocked) {
                                                        handleDeleteActionBtn(action?.whatsapp_template_button_type_id, action?.whatsapp_template_button_data[0]?.whatsapp_template_button_sub_type_id, 0, openButtonIndex);
                                                        handlePopoverClose();
                                                    }
                                                }} 
                                            />

                                            <CloseIcon 
                                                className={`${globalStyles.displayFlex} ${styles.buttonPreviewPopover__closeActionButton}`}
                                                onClick={() => handlePopoverClose()}
                                                sx={{ fontSize: "10px", cursor: "pointer", color: blackColor }}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} sx={{ justifyContent: 'start', gap: '15px', alignItems: 'center' }} flexWrap={"nowrap"}
                                        className={styles.buttonPreviewPopover__callToActionGrid__content}
                                    >
                                        <Grid item xs={12}>
                                            {action?.whatsapp_template_button_data?.map((field: any, whatsappTemplateButtonDataIndex: number) => {
                                                return (
                                                    <React.Fragment key={whatsappTemplateButtonDataIndex}>
                                                        <Grid container direction={{ xs: "column" }} gap={"15px"} alignItems={{ xs: "start" }} justifyContent={"start"} flexWrap={!isScreenBelow1600 ? "nowrap" : "wrap"} marginBottom={0.5} className={styles.mobileViewActions}>
                                                            
                                                            <Grid item xs={12} sx={{ width: "100%" }}>
                                                                <Grid container direction={"row"} alignItems={"center"} gap={0.5} flexWrap={"nowrap"}>
                                                                    <Grid item xs={3.5}>
                                                                        <InputLabel className={styles.buttonPreviewPopover__formLabel}>
                                                                            Type of action
                                                                        </InputLabel>
                                                                    </Grid>
                                                                    <Grid item xs={8.5}>
                                                                        <Select
                                                                            disabled={isButtonActionLocked}
                                                                            labelId="demo-simple-select-label"
                                                                            id="demo-simple-select"
                                                                            fullWidth
                                                                            size='small'
                                                                            placeholder='Select action type'
                                                                            className={styles.buttonPreviewPopover__templateGlobalDropdown}
                                                                            value={field?.whatsapp_template_button_sub_type_id}
                                                                            // @ts-ignore
                                                                            onChange={(event: any) => { handleChangeCallField(event.target.value, 'type', action.id); handleChangeFieldVal(event.target.value, openButtonIndex, whatsappTemplateButtonDataIndex, action.whatsapp_template_button_type_id) }}
                                                                            MenuProps={{
                                                                                disablePortal: true,
                                                                                anchorOrigin: {
                                                                                    vertical: 'bottom',
                                                                                    horizontal: 'left'
                                                                                },
                                                                                transformOrigin: {
                                                                                    vertical: 'top',
                                                                                    horizontal: 'left'
                                                                                }
                                                                            }}
                                                                        >
                                                                            {/* @ts-ignore */}
                                                                            {(whatsappTemplateButtonGenericData?.find((btn) => String(btn?.whatsapp_template_button_type_id) === String(action?.whatsapp_template_button_type_id))?.whatsapp_template_button_sub_type_data ?? []).map((ele, ind) => (
                                                                                // @ts-ignore
                                                                                <MenuItem
                                                                                    // @ts-ignore
                                                                                    // disabled={ele.whatsapp_template_button_sub_type_id == 3 ? createTemplatePayload.whatsapp_template_data.whatsapp_template_button.find((btn) => btn.whatsapp_template_button_type_id == action.whatsapp_template_button_type_id).whatsapp_template_button_data.filter((btn: any) => btn.whatsapp_template_button_sub_type_id == 3).length == 2 ? true : false : createTemplatePayload.whatsapp_template_data.whatsapp_template_button.find((btn) => btn.whatsapp_template_button_type_id == action.whatsapp_template_button_type_id).whatsapp_template_button_data.filter((btn: any) => btn.whatsapp_template_button_sub_type_id == 4).length == 1 ? true : false}
                                                                                    disabled={getMenuDisableFlag(ele?.whatsapp_template_button_type_id, ele)}
                                                                                    value={ele?.whatsapp_template_button_sub_type_id}
                                                                                    key={ind}
                                                                                >
                                                                                    {ele?.whatsapp_template_button_sub_type_name}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>

                                                            {(isCustomBtn(getSubBtnNameFromGenericData(whatsappTemplateButtonGenericData, action?.whatsapp_template_button_type_id, field?.whatsapp_template_button_sub_type_id)) ? // ReOrder Field for Custom Button
                                                                renderCustomButtonField(field, openButtonIndex, action, whatsappTemplateButtonDataIndex)
                                                                :
                                                                field?.whatsapp_template_button_sub_type_field_data?.filter((field: any) => (field?.field_name?.toLowerCase() !== "flow payload object" && field?.field_name?.toLowerCase() !== "flow input payload")).sort((a: any, b: any) => a?.whatsapp_template_button_sub_type_field_id - b?.whatsapp_template_button_sub_type_field_id)
                                                            ).map((subField: any, subFieldIndex: any) => {
                                                                return (
                                                                    <React.Fragment key={subFieldIndex}>
                                                                        <Grid item xs={12} className={globalStyles.fullwidth}>
                                                                            {getInput(openButtonIndex, subField.field_type, subField, action.whatsapp_template_button_type_id, whatsappTemplateButtonDataIndex, subFieldIndex, field.whatsapp_template_button_sub_type_id, field.whatsapp_template_button_sub_type_field_data, undefined, undefined, true)}     
                                                                        </Grid>

                                                                        {flagShowVariableTooltipForVisitWebsite(subField, field?.whatsapp_template_button_sub_type_field_data) && 
                                                                            <Grid item xs={12} className={styles.buttonPreviewPopover__visitWebsiteVariableText}>
                                                                                <span className={styles.visitWebsiteVariableKeyText}>
                                                                                    {`{{1}}`}
                                                                                </span>
                                                                                
                                                                                <TouchTooltip title={dynamicUrlVisitWebsiteBtnTooltipText()} >
                                                                                    <span className={`${globalStyles.clickable} ${styles.visitWebsiteVariableInfoIcon}`}>
                                                                                        <IconsColor fillColor={primaryColor} iconName="info" height="13" width="13" />
                                                                                    </span>
                                                                                </TouchTooltip>
                                                                            </Grid>
                                                                        }
                                                                    </React.Fragment>
                                                                )
                                                            })}
                                                        </Grid>

                                                        {checkForAddDynamicVar(action, field) &&
                                                            <Grid container>
                                                                <Grid item xs={12} sx={{ margin: '6px 0px 8px 0px', paddingBottom: "5px" }}>
                                                                    <Grid container direction={"row"} alignItems={"center"} gap={0.5} flexWrap={"nowrap"}
                                                                        className={formStyles.whatsappTemplateFormButtons__sampleVariableRow}
                                                                    >
                                                                        <Grid item xs={3.5}>
                                                                            <Typography
                                                                                component='span'
                                                                                className={`${formStyles.sampleVariableKeyText} ${formStyles.whatsappTemplateFormButtons__sampleVariableKey}`}
                                                                            >
                                                                                {'{{1}}'}
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item xs={8.5} key={field?.whatsapp_template_button_sub_type_id}>
                                                                            <TextField
                                                                                size='small'
                                                                                variant="outlined"
                                                                                className={styles.buttonPreviewPopover__templateGlobalTextfield} 
                                                                                disabled={createTemplatePayload?.whatsapp_template_id ? true : false}
                                                                                onChange={(e) => handleSampleTextChange(openButtonIndex, whatsappTemplateButtonDataIndex, e.target.value, true)} 
                                                                                placeholder={`Enter full URL for ${getWebsiteUrlValue(field?.whatsapp_template_button_sub_type_field_data)}`}
                                                                                // onBlur={(e) => handleValidWebsite(e.target.value, "Website URL", String(whatsappTemplateButtonDataIndex+index))}
                                                                                fullWidth
                                                                                autoComplete='off'
                                                                                inputProps={{ dir: 'auto' }}
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                                        border: inValidId.includes(String(whatsappTemplateButtonDataIndex + openButtonIndex)) ? '1px solid red' : '#D7D7D7',
                                                                                        borderRadius: '10px',
                                                                                    }
                                                                                }}
                                                                                value={
                                                                                    createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.find((btn: any, ind: number) => ind === openButtonIndex)
                                                                                        ?.whatsapp_template_button_data?.find((field: any, ind: number) => ind === whatsappTemplateButtonDataIndex)
                                                                                        ?.whatsapp_template_button_sub_type_field_data?.find((subType: any) => subType?.field_name?.toLowerCase() === "website url")
                                                                                        ?.whatsapp_template_button_field_data_variable?.[0]?.whatsapp_template_dynamic_variable_sample_value || ""
                                                                                }
                                                                            />

                                                                            {inValidId.includes(String(whatsappTemplateButtonDataIndex + openButtonIndex)) && 
                                                                                <span className={formStyles.errorTextWithTopMargin}>
                                                                                    Please Enter Valid URL
                                                                                </span>
                                                                            }
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                                
                                                                {
                                                                    (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.find((btn: any, ind: number) => ind === openButtonIndex)
                                                                        ?.whatsapp_template_button_data?.find((field: any, ind: number) => ind === whatsappTemplateButtonDataIndex)
                                                                        ?.whatsapp_template_button_sub_type_field_data?.find((subType: any) => subType?.field_name?.toLowerCase() === "website url")
                                                                        ?.whatsapp_template_button_field_data_variable?.[0]?.whatsapp_template_dynamic_variable_sample_value || "").length === 0 &&

                                                                    <Grid item xs={12} sx={{ paddingBottom: "12px" }}>
                                                                        <VariableDisclaimer text="Add sample URL" />
                                                                    </Grid>
                                                                }
                                                            </Grid>
                                                        }
                                                    </React.Fragment>
                                                )
                                            })
                                            }
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </React.Fragment>
                        )
                    })}
                </Popover>
            }
        </>
    )
};

export default WhatsAppMessageButtonsPreview;